import { Entity } from '@backstage/catalog-model';
import { ConfigHelper, Feature } from '@devxdiscover/devhub-common';

/**
 * Indicates whether a feature is enabled.
 * @param feature - The feature to check.
 */
export function isFeatureAvailable(
  feature: Feature,
): (entity: Entity) => boolean {
  return (_entity: Entity): boolean => {
    return ConfigHelper.instance.isFeatureEnabled(feature);
  };
}

/**
 * Indicates whether the entity is a cable entity.
 * @param corporateEntity - The entity to check.
 */
export function isCableEntity(
  corporateEntity: string,
): (_entity: Entity) => boolean {
  return (_entity: Entity): boolean => {
    return corporateEntity === 'Cable';
  };
}
